// Reminders helper using browser Notifications API + setInterval
const STORAGE_KEY = "haccp_reminders_v1";

const DEFAULT_TIMES = ["09:00", "17:00"];
const DEFAULT_LABEL = "Promemoria HACCP: registra controlli di pulizia e igiene del negozio.";

export function getReminderConfig() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) return JSON.parse(raw);
    } catch {}
    return { enabled: true, times: DEFAULT_TIMES };
}

export function saveReminderConfig(cfg) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg));
}

export async function ensurePermission() {
    if (!("Notification" in window)) return "unsupported";
    if (Notification.permission === "default") {
        try {
            return await Notification.requestPermission();
        } catch {
            return Notification.permission;
        }
    }
    return Notification.permission;
}

function isSameMinute(d, hhmm) {
    const [h, m] = hhmm.split(":").map(Number);
    return d.getHours() === h && d.getMinutes() === m;
}

function notifKey(hhmm) {
    const d = new Date();
    return `haccp_notif_${d.toISOString().slice(0, 10)}_${hhmm}`;
}

function fire(hhmm) {
    const k = notifKey(hhmm);
    if (sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k, "1");
    try {
        new Notification("Samir Ortofrutta · HACCP", {
            body: DEFAULT_LABEL,
            icon: "/favicon.ico",
            tag: k,
        });
    } catch {}
}

let interval = null;

export function startReminderLoop() {
    if (interval) return;
    const tick = () => {
        const cfg = getReminderConfig();
        if (!cfg.enabled) return;
        if (!("Notification" in window) || Notification.permission !== "granted") return;
        const now = new Date();
        for (const t of cfg.times) {
            if (isSameMinute(now, t)) fire(t);
        }
    };
    tick();
    interval = setInterval(tick, 30 * 1000); // every 30s
}

export function stopReminderLoop() {
    if (interval) {
        clearInterval(interval);
        interval = null;
    }
}
